export enum ContractorReviewSource {
  YARDZEN = "YARDZEN",
  GOOGLE = "GOOGLE",
  YELP = "YELP",
  HOUZZ = "HOUZZ",
  HOMEADVISOR = "HOMEADVISOR",
}
